import * as React from "react";
import './CreditCardFC.css';
import { FormatDate } from "../shared";

const CreditCardFC = props => (  
  <div class="WordSection1">
    <p class="MsoNormal word1"><span class="word2">&nbsp;</span></p>
    <table class="MsoTableGrid word3" border="0" cellspacing="0" cellpadding="0" width="100%">
    <tr>
    <td width="68%" valign="top" class="word4">
    <p class="MsoNormal word1"><span class="word2"> </span></p>
    <table class="MsoTableGrid word3" border="0" cellspacing="0" cellpadding="0" width="100%">
       <tr>
        <td width="100%" colspan="2" valign="top" class="word5">
        <p class="MsoNormal word1"><span class="word6">CARD payment information</span></p>
        </td>
       </tr>
       <tr>
        <td width="100%" colspan="2" valign="top" class="word7">
        <p class="MsoNormal word1"><span class="word2">&nbsp;</span></p>
        </td>
       </tr>
       <tr>
        <td width="100%" colspan="2" valign="top" class="word8">
        <p class="MsoNormal word1"><span class="word2">&nbsp;</span></p>
        </td>
       </tr>
       <tr>
        <td width="50%" valign="top" class="word9">
        <p class="MsoNormal word10" align="center"><span class="word11">Payment Amount</span></p>
        <p class="MsoNormal word10" align="center"><span class="word12">{props.cardLimit}</span><span class="word13">{props.currency}</span></p>
        </td>
        <td width="50%" valign="top" class="word9">
        <p class="MsoNormal word10" align="center"><span class="word11">Payment From</span></p>
        <p class="MsoNormal word10" align="center"><span class="word14">Flight Centre Travel GROUP</span></p>
        </td>
       </tr>
       <tr>
        <td width="100%" colspan="2" valign="top" class="word5">
        <p class="MsoNormal word1"><span class="word2">&nbsp;</span></p>
        </td>
       </tr>
       <tr>
        <td width="100%" colspan="2" valign="top" class="word5">
        <p class="MsoNormal word1"><span class="word15">Please take your payment within the designated timeframe. Failure to do so can result in your funds expiring.</span></p>
        </td>
       </tr>
       <tr>
        <td width="100%" colspan="2" valign="top" class="word5">
        <p class="MsoNormal word1"><span class="word2">&nbsp;</span></p>
        </td>
       </tr>
       <tr>
        <td width="50%" valign="top" class="word9">
        <p class="MsoNormal word16" align="right">
          <div class="credit-card-box">
            <div>
              <div class="front">
                <div class="logocorp corporatelogo flightcentre"></div>
                <div class="logoright cclogo {props.provider}"></div>
                <div class="number">{props.number.substr(0, 4)}&nbsp;{props.number.substr(4, 4)}&nbsp;{props.number.substr(8, 4)}&nbsp;{props.number.substr(12, 4)}</div>
                <div class="card-holder">
                  <label>CARD HOLDER</label>
                  <div name="vc-card-holder">Flight Centre Travel Group</div>
                </div>
                <div class="card-expiration-date">
                  <label>EXPIRY</label>
                  <div name="vc-valid-to">{props.expiry}</div>
                </div>
              </div>
            </div>
          </div>
        </p>
        </td>
        <td width="50%" valign="top" class="word9">
        <p class="MsoNormal word1">
          <div class="credit-card-box box-right">
            <div>
              <div class="back">
                <div class="strip"></div>
                <div class="cvv">
                  <strong>CVV</strong>
                  <div name="vc-cvv">{props.cvv}</div>
                </div>
              </div>                    
            </div>
          </div>
        </p>
        </td>
       </tr>
       <tr>
        <td width="100%" colspan="2" valign="top" class="word5">
        <p class="MsoNormal word1"><span class="word2">&nbsp;</span></p>
        </td>
       </tr>
       <tr>
        <td width="50%" valign="top" class="word9">
        <p class="MsoNormal word1"><span class="word11">Name on card: </span><span class="word17">Flight Centre Travel GROUP</span></p>
        </td>
        <td width="50%" valign="top" class="word9">
        <p class="MsoNormal word1 box-right"><span class="word11">Billing address: </span><span class="word17">275 Grey Street, SOUTH BRISBANE QLD 4101, AUSTRALIA</span></p>
        </td>
       </tr>
       <tr>
        <td width="100%" colspan="2" valign="top" class="word5">
        <p class="MsoNormal word1"><span class="word2">&nbsp;</span></p>
        </td>
       </tr>
       <tr>
        <td width="100%" colspan="2" valign="top" class="word5">
        <p class="MsoNormal word1">
            <a href="#" onclick="{CopyCardNumber('props.number')}">
                <img width="122" height="29" id="imgCopyCardNumber" src="data:image/png;base64,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" />
            </a>
        </p>
        </td>
       </tr>
      </table>
      <p class="MsoNormal word1"><span class="word2"> </span></p>
      </td>
      <td width="31%" valign="top" class="word18">
      <p class="MsoNormal word1"><span class="word2">&nbsp;</span></p>
      <table class="MsoTableGrid word3" border="0" cellspacing="0" cellpadding="0" width="100%">
       <tr>
        <td width="6%" valign="top" class="word19">
        <p class="MsoNormal word1"><span class="word2">&nbsp;</span></p>
        </td>
        <td width="86%" valign="top" class="word20">
        <p class="MsoNormal word1"><span class="word23"><div class="issuerlogo {props.type}"></div></span></p>
        </td>
        <td width="6%" valign="top" class="word21">
        <p class="MsoNormal word1"><span class="word2">&nbsp;</span></p>
        </td>
       </tr>
       <tr>
        <td width="100%" colspan="3" valign="top" class="word22">
        <p class="MsoNormal word1"><span class="word2">&nbsp;</span></p>
        </td>
       </tr>
       <tr>
        <td width="6%" valign="top" class="word19">
        <p class="MsoNormal word1"><span class="word2">&nbsp;</span></p>
        </td>
        <td width="86%" valign="top" class="word24">
        <p class="MsoNormal word1"><span class="word25">Payment detail</span></p>
        </td>
        <td width="6%" valign="top" class="word21">
        <p class="MsoNormal word1"><span class="word2">&nbsp;</span></p>
        </td>
       </tr>
       <tr>
        <td width="6%" valign="top" class="word19">
        <p class="MsoNormal word1"><span class="word2">&nbsp;</span></p>
        </td>
        <td width="86%" valign="top" class="word24">
        <p class="MsoNormal word1"><span class="word26">Payment date</span></p>
        <p class="MsoNormal word1"><span class="word25">{FormatDate(props.dateTimeUtc)}</span></p>
        </td>
        <td width="6%" valign="top" class="word21">
        <p class="MsoNormal word1"><span class="word2">&nbsp;</span></p>
        </td>
       </tr>
       <tr>
        <td width="6%" valign="top" class="word19">
        <p class="MsoNormal word1"><span class="word2">&nbsp;</span></p>
        </td>
        <td width="86%" valign="top" class="word24">
        <p class="MsoNormal word1"><span class="word27">Wex/eNett ID</span></p>
        <p class="MsoNormal word1"><span class="word25">{props.providerId}</span></p>
        </td>
        <td width="6%" valign="top" class="word21">
        <p class="MsoNormal word1"><span class="word2">&nbsp;</span></p>
        </td>
       </tr>
       <tr>
        <td width="6%" valign="top" class="word19">
        <p class="MsoNormal word1"><span class="word2">&nbsp;</span></p>
        </td>
        <td width="86%" valign="top" class="word24">
        <p class="MsoNormal word1"><span class="word27">Customer information</span></p>
        <p class="MsoNormal word1"><span class="word25">Flight Centre Travel GROUP</span></p>
        <p class="MsoNormal word1"><span class="word29">275 Grey Street</span></p>
        <p class="MsoNormal word1"><span class="word29">SOUTH BRISBANE QLD 4101</span></p>
        <p class="MsoNormal word1"><span class="word29">Australia</span></p>
        </td>
        <td width="6%" valign="top" class="word21">
        <p class="MsoNormal word1"><span class="word2">&nbsp;</span></p>
        </td>
       </tr>
       <tr>
        <td width="6%" valign="top" class="word19">
        <p class="MsoNormal word1"><span class="word2">&nbsp;</span></p>
        </td>
        <td width="86%" valign="top" class="word24">
        <p class="MsoNormal word1"><span class="word27">Company Booking</span></p>
        <p class="MsoNormal word1"><span class="word25">{props.userDefinedFields.Company_Booking}</span></p>
        </td>
        <td width="6%" valign="top" class="word21">
        <p class="MsoNormal word1"><span class="word2">&nbsp;</span></p>
        </td>
       </tr>
       <tr>
        <td width="6%" valign="top" class="word19">
        <p class="MsoNormal word1"><span class="word2">&nbsp;</span></p>
        </td>
        <td width="86%" valign="top" class="word24">
        <p class="MsoNormal word1"><span class="word27">Component Arrival Date</span></p>
        <p class="MsoNormal word1"><span class="word25">{props.userDefinedFields.Component_Arrival_Date}</span></p>
        </td>
        <td width="6%" valign="top" class="word21">
        <p class="MsoNormal word1"><span class="word2">&nbsp;</span></p>
        </td>
       </tr>
       <tr>
        <td width="6%" valign="top" class="word19">
        <p class="MsoNormal word1"><span class="word2">&nbsp;</span></p>
        </td>
        <td width="86%" valign="top" class="word20">
        <p class="MsoNormal word1"><span class="word27">Kuggar ID</span></p>
        <p class="MsoNormal word1"><span class="word25">{props.kuggarId}</span></p>
        </td>
        <td width="6%" valign="top" class="word21">
        <p class="MsoNormal word1"><span class="word2">&nbsp;</span></p>
        </td>
       </tr>
      </table>
      <p class="MsoNormal word1"><span class="word2"> </span></p>
      </td>
     </tr>
    </table>
    <p class="MsoNormal word1"><span class="word2">&nbsp;</span></p>
    </div>
);

export default CreditCardFC;
